(function () {
    'use strict';

    var module = angular.module('uwAgenda.programinfo');
    module.directive('programInfo', ['$window', '$templateCache', '$compile', '$rootScope', '$uibModal', '$translate', 'ProgramInfoService', 'Alert', ProgramInfoFn]);

    function ProgramInfoFn($window, $templateCache, $compile, $rootScope, $uibModal, $translate, ProgramInfoService, Alert) {

        var template = '/app/programinfo/templates/program-info.template.html';

        var directive = {
            restrict: 'A',
            templateUrl: template,
            link: link,
            scope: {}
        };

        return directive;

        function link(scope, element) {


            scope.unread = 0;
            scope.show = show;
            scope.remove = remove;
            scope.create = create;
            scope.openLinkInNewTab = openLinkInNewTab;
            scope.isRingfoon = $rootScope.isRingfoon;
            scope.notifications = [];

            // get the template cached used to build this directive
            var cachedTemplate = $templateCache.get(template);

            // init directive
            activate();

            // activate
            function activate() {
                // initial list load
                ProgramInfoService.fetchNotifications().then(function (notificationList) {
                    updateVM(notificationList, cachedTemplate);
                    findUnread();
                });

                // if a message gets deleted updatee notification list
                var deleteListener = scope.$on(ProgramInfoService.Broadcast.ProgramInfoDelete, function (event, notificationList) {
                    // update notification list
                    updateVM(notificationList, cachedTemplate);
                });

                // if a new notification was saved
                var saveListener = scope.$on(ProgramInfoService.Broadcast.ProgramInfoUpdate, function (event, notificationList) {
                    updateVM(notificationList, cachedTemplate);

                    // check if any unread messages are in the list
                    findUnread();

                });

                // destroy listeners
                scope.$on("$destroy", function () {
                    saveListener();
                    saveListener = null;

                    deleteListener();
                    deleteListener = null;
                });

            }

            // find unread messages
            function findUnread() {
                // check if any unread messages are in the list
                var i = 0;
                var length = scope.notifications.length;
                var anyUnread = false;
                for (i = 0; i < length; i++) {
                    if (false === scope.notifications[i].readByCurrentUser) {
                        anyUnread = true;
                    }
                }

                // if there is/are any unread notification/s show notification popup
                if (true === anyUnread) {
                    open();
                }
            }


            // open dropdown
            function open() {
                if (window.outerWidth < 641) { return; }
                
                element.find('.dropdown-toggle').dropdown('toggle');
            }

            function toggle() {
                element.find('.dropdown-toggle').dropdown('toggle');
            }

            function openLinkInNewTab(event, hyperLink) {
                event.stopPropagation();
                event.preventDefault();

                $window.open(hyperLink, '_blank');
            }

            // refactor drop down menu info screen
            function makeElement(cachedTemplate) {

                // empty current element
                element.empty();
                // compile template
                var el = $compile(cachedTemplate)(scope);
                // append compiled template file
                element.append(el);
                // element.find('.dropdown-toggle').hover(function(){
                //    element.find('.dropdown-toggle').dropdownHover(); //.dropdown('toggle');
                // });

                // slim scroll
                var se = element.find('#scrolli');
                se.slimScroll({ height: '40vh' });
            }

            // update view model
            function updateVM(notificationList, cachedTemplate) {
                scope.notifications = notificationList;
                makeElement(cachedTemplate);
            }

            // open create modal
            function create() {
                // modal
                var modalInstance = null;

                modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    animation: true,
                    templateUrl: '/app/programinfo/templates/program-info-create.template.html',
                    controller: 'ProgramInfoCreateController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        languages: ['AdministrationService', function (AdministrationService) {
                            return AdministrationService.languages();
                        }]
                    }
                });
                // handle storing notification
                modalInstance.result.then(function (notification) {
                    Alert.success("New Program info published");
                }, function () {
                    // dismissed
                });

            }

            // remove info
            function remove(info) {
                // propagate remove to api
                ProgramInfoService.removeNotification(info).then(function () {
                    // show loading or progress
                    Alert.success("Program info removed");
                });
            }

            // open modal with detailed information
            function show(info) {

                toggle();       // closes the open dropdown

                // modal
                var modalInstance = null;

                modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    animations: true,
                    templateUrl: '/app/programinfo/templates/program-info-read.template.html',
                    controller: 'ProgramInfoReadController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        info: info
                    }
                });

                modalInstance.result.then(function (message) {
                    if (message) {
                        Alert.success(message);
                    }
                });

            } // show


        }

    }

})();
